module.exports = __webpack_public_path__ + "img/ts17.1cea05d4.png";